angular
    .module("app")
    .controller(
        "TestNotesController",
        function($scope, $window, $uibModal, $uibModalInstance, moment, TraceHubExService, TestNotesService, userDetails) {
            var vm = this;
            $window.vm = vm;
            vm.state = {};
            vm.data = {
                notes: []
            };
            vm.userDetails = userDetails;

            vm.close = close;
            vm.viewTraceDetails = viewTraceDetails;
            vm.resolve = resolve;

            vm.$onInit = function() {
                //renderTestNotes();
                TestNotesService.unreadTestNotes().then(function(response) {
                    vm.data.notes = response.data;
                });
            };

            vm.getFromNowString = function(utcTime) {
                return moment.utc(utcTime).local().fromNow();
            };

            // TODO: See if we need the promise
            function renderTestNotes() {
                return TestNotesService.unreadTestNotes().then(
                    function(response) {
                        vm.data.notes = response.data;
                    }
                );
            }

            function close() {
                $uibModalInstance.dismiss();
            }

            function viewTraceDetails(traceId) {
                //$uibModalInstance.close(traceId);
                // TODO: open trace details here
                if (traceId == null) {
                    return;
                }
                TestNotesService.selectedItems(traceId)
                .then(function(response) {
                    // TODO: Rationalise this
                    // TODO: Change SelectedItems to selectedItems
                    var items = response.data;
                    var selectedItems = {
                        selectedTester: items.Tester,
                        selectedSim: items.Sim,
                        selectedSuite: items.Suite,
                        selectedTest: items.Test,
                        projectIterationId: items.ProjectIterationId
                    };

                    var mode = { view: false, run: false };
                    var tdParams = {
                        selectedItems: selectedItems,
                        mode: mode,
                        user: items.Tester
                    };
                    var modalInstance = $uibModal.open({
                        animation: true,
                        size: 'xl',
                        backdrop: 'static',
                        component: 'traceDetailsModal',
                        resolve: {
                            params: function() {
                                return tdParams;
                            }
                        }
                    });
                    modalInstance.result.then(
                        // close callback
                       console.log('trace-details closed')
                    );
                });
            }

            function resolve(sysMsgId) {
                TestNotesService.resolve(sysMsgId).then(function() {
                    // TestNotesService.unreadTestNotes().then(function (response) {
                    //     vm.data.notes = response.data;
                    //     if (vm.data.notes.length == 0) { vm.close(); }
                    // });
                    renderTestNotes().then(function() {
                        if (vm.data.notes.length == 0) {
                            vm.close();
                        }
                    });
                });
            }

            var hub = TraceHubExService;
            hub.connect('nav-notes');

            // Stop SignalR when controller is destroyed. Ref: http://stackoverflow.com/questions/17813094/signalr-connection-freeze-other-ajax-requests
            $scope.$on("$destroy", function() {
                hub.stop("nav-notes");
            });

            hub.on("onTestNote", function() {
                renderTestNotes();
            });
        }
    );
